import request from "@/utils/request";
import { Boutique } from '@/enum/index'
interface HousePlanParams {
    boutique?: Boutique,
    hasImage?: boolean
}

export function searchHousePlan(params: HousePlanParams) {
    return request.post('/app/v1/housePlan/page',  params)
}

